import { Link } from "react-router-dom";
import { Play, Mic, Captions, Download } from "lucide-react";
import { OFFRES_LIST } from "../../offres";
import { ShareWhatsApp } from "../ShareWhatsApp";

export const PRESENTATION = {
  slug: "presentation", nom: "Présentation Patient Vitalis Care", videoVoix: true, videoDuree: "3:12", lien: "/nos-offres#presentation",
  video: "/videos/vitalis-patient-vitalis-care-presentation.mp4", videoPoster: "/videos/vitalis-patient-vitalis-care-presentation.jpg",
  videoCourte: "/videos/vitalis-patient-vitalis-care-court-vertical.mp4",
};

export function PresentationVideo({ testid = "presentation-video-section", id = "presentation" }) {
  return (
    <section id={id} className="mx-auto max-w-5xl scroll-mt-24 px-4 pt-12 sm:px-6" data-testid={testid}>
      <h2 className="font-display text-base font-bold uppercase tracking-wider text-[#0369A1] md:text-lg">Patient Vitalis Care en 3 minutes</h2>
      <p className="mt-2 text-sm text-slate-600">Dr ANON Barthélémy, fondateur du Cabinet CARIS Santé, présente la solution.</p>
      <video controls preload="metadata" poster={PRESENTATION.videoPoster} src={PRESENTATION.video} data-testid="presentation-video" className="mt-5 w-full rounded-2xl border border-[#7DC4E8] bg-[#0C4A6E] shadow-sm" />
      <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold text-[#0369A1]">
        <a href={PRESENTATION.video} download data-testid="presentation-download" className="inline-flex items-center gap-2 hover:underline"><Download size={15} /> Télécharger la vidéo (MP4)</a>
        <a href={PRESENTATION.videoCourte} download data-testid="presentation-courte-download" className="inline-flex items-center gap-2 hover:underline"><Download size={15} /> Version courte 45 s (WhatsApp)</a>
        <ShareWhatsApp video={PRESENTATION.videoCourte} titre="Patient Vitalis Care" testid={`${testid}-share`} />
      </div>
    </section>
  );
}

export function GalerieVideos() {
  const items = OFFRES_LIST.filter((o) => o.video).sort((a, b) => Number(b.videoVoix) - Number(a.videoVoix));
  items.unshift(PRESENTATION);
  return (
    <section className="mx-auto max-w-7xl px-4 pb-14 sm:px-6" data-testid="galerie-videos">
      <h2 className="font-display text-base font-bold uppercase tracking-wider text-[#0369A1] md:text-lg">Les offres en vidéo</h2>
      <p className="mt-2 max-w-2xl text-sm text-slate-600">Découvrez chaque offre en moins de 2 minutes. Cliquez pour ouvrir la démonstration sur la page de l'offre. <Link to="/videos-whatsapp" data-testid="galerie-lien-whatsapp" className="font-semibold text-[#0369A1] hover:underline">Versions courtes à partager sur WhatsApp</Link></p>
      <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {items.map((o) => (
          <Link key={o.slug} to={o.lien || `/offres/${o.slug}#video`} onClick={o.lien ? () => setTimeout(() => document.getElementById("presentation")?.scrollIntoView({ behavior: "smooth" }), 50) : undefined} data-testid={`galerie-video-${o.slug}`}
            className="group overflow-hidden rounded-2xl border border-[#7DC4E8] bg-white shadow-sm transition-transform duration-200 hover:-translate-y-1">
            <div className="relative aspect-video overflow-hidden bg-[#E0F2FE]">
              <img src={o.videoPoster} alt={`Vidéo ${o.nom}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#0369A1]/90 text-white shadow-lg transition-transform group-hover:scale-110"><Play size={20} className="ml-0.5" /></span>
              </span>
              <span className="absolute bottom-2 right-2 rounded-md bg-[#0C4A6E]/85 px-1.5 py-0.5 text-[11px] font-semibold text-white" data-testid={`galerie-duree-${o.slug}`}>{o.videoDuree}</span>
            </div>
            <div className="p-3">
              <p className="text-sm font-semibold text-[#0C4A6E]">{o.nom}</p>
              <p className={`mt-1 inline-flex items-center gap-1 text-[11px] font-medium ${o.videoVoix ? "text-emerald-700" : "text-slate-500"}`} data-testid={`galerie-statut-${o.slug}`}>
                {o.videoVoix ? <><Mic size={11} /> Commentée par Dr ANON</> : <><Captions size={11} /> Sous-titrée · voix bientôt</>}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
